import React from 'react';

/** Order for displaying assistance codes (matches common PRM reporting) */
const CODE_ORDER = [
    'BDGR', 'BLND', 'DEAF', 'DPNA', 'LNYD', 'MAAS', 'MEDA', 'PETC', 'PREBOARDHS',
    'WCBD', 'WCHC', 'WCHP', 'WCHR', 'WCHS', 'WCLB', 'WCMP', 'WELLCHK',
    'SVAN', 'STCR', 'WCBW', 'PPOC', 'ESAN', 'OXYG',
];

const headerStyle = {
    border: '1px solid #e5e7eb',
    padding: '8px 10px',
    textAlign: 'center',
    backgroundColor: '#f9fafb',
    fontWeight: 600,
    fontSize: '12px',
    color: '#374151',
};

const cellStyle = {
    border: '1px solid #e5e7eb',
    padding: '8px 10px',
    textAlign: 'center',
    fontSize: '12px',
    color: '#1f2937',
};

const tableStyle = {
    border: '1px solid #e5e7eb',
    borderCollapse: 'collapse',
    width: '100%',
    tableLayout: 'auto',
    marginBottom: '12px',
};

/**
 * Compact assistance breakdown table – one row of counts per PRM code.
 *
 * @param {Object} props
 * @param {Array<{ assistanceCode: string, passengerCount: number }>} props.breakdown - From backend
 * @param {string} [props.title] - Section label (e.g. "Outbound", "Inbound")
 */
const MovementAssistanceBreakdown = ({ breakdown, title }) => {
    if (!breakdown?.length) {
        return null;
    }

    const countsByCode = breakdown.reduce((acc, { assistanceCode, passengerCount }) => {
        acc[assistanceCode] = passengerCount;
        return acc;
    }, {});

    const orderedCodes = CODE_ORDER.filter((c) => countsByCode[c] != null);
    const otherCodes = Object.keys(countsByCode).filter((c) => !CODE_ORDER.includes(c));
    const displayCodes = [...orderedCodes, ...otherCodes.sort()];

    const total = Object.values(countsByCode).reduce((sum, n) => sum + n, 0);

    return (
        <div style={{ marginBottom: '12px' }}>
            <p style={{ fontSize: '12px', fontWeight: 500, color: '#6b7280', margin: '0 0 8px' }}>
                Assistance breakdown
            </p>
            <div style={{ overflowX: 'auto' }}>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={{ ...headerStyle, textAlign: 'left', minWidth: '80px' }}>Category</th>
                            {displayCodes.map((code) => (
                                <th key={code} style={headerStyle}>
                                    {code}
                                </th>
                            ))}
                            <th style={headerStyle}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ ...cellStyle, textAlign: 'left', fontWeight: 500 }}>{title || 'Count'}</td>
                            {displayCodes.map((code) => (
                                <td key={code} style={cellStyle}>
                                    {countsByCode[code] ?? 0}
                                </td>
                            ))}
                            <td style={{ ...cellStyle, fontWeight: 600 }}>{total}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MovementAssistanceBreakdown;
